<template>
  <el-select v-model="selectedValue" :placeholder="placeholder"
   :filterable="filterable" :clearable="clearable" :size="size"
   @change="onSelectedValueChanged">
    <el-option
      v-for="item in options"
      :key="item[keyField]"
      :label="item[labelField]"
      :value="item[valueField]"
      :style="{'display': (item.isParent || item.visible) ? 'list-item': 'none'}">
      <template>
        <span v-if="item.isParent">
          <template v-if="item[childrenField] && item[childrenField].length > 0">
            <i v-if="item.collapse" class="el-icon-caret-right" v-on:click="onExpandClick(item, $event)">&nbsp;</i>
            <i v-else class="el-icon-caret-bottom" v-on:click="onCollapseClick(item, $event)">&nbsp;</i>
          </template>
          <label>{{item[labelField]}}</label>
        </span>
        <span class="__tree-select-child-item" v-else>
          {{item[labelField]}}
        </span>
      </template>
    </el-option>
  </el-select>
</template>

<style lang="scss" scoped>
  .__tree-select-child-item {
    padding-left: 30px;
  }
</style>


<script>
// import ElementUI from 'element-ui';
// Vue.use(ElementUI);

export default {
    props: {
      "key-field": String,
      "label-field": String,
      "value-field": String,
      "children-field": String,
      "data-source": Array,
      "size": String,
      "value": Object,
      "default-collapse": {
          type: Boolean,
          default: false
      },
      "placeholder": {
        type: String,
        default: "请选择"
      },
      "filterable": {
        type: Boolean,
        default: true
      },
      "clearable": {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        options: [],
        selectedValue: null
      }
    },
    methods: {
      init(){
        const input = this.dataSource;
        const collapse = this.defaultCollapse;
        
        let dataSource = [];
        
        for ( let i = 0; i <input.length; i++ ) {
          const curr = input[i];
          const cloned = JSON.parse(JSON.stringify(curr));
          const children = cloned[this.childrenField];
          cloned.collapse = collapse;
          cloned.isParent = true;
          cloned[this.keyField] = (cloned[this.keyField] || '').toString();
          
          dataSource.push(cloned);
          
          dataSource.push(... children.map((v, i, a) => {
            const clonedChild = JSON.parse(JSON.stringify(v));
            clonedChild[this.keyField] = "--children--" + clonedChild[this.keyField];
            clonedChild.isParent = false;
            clonedChild.parentKey = cloned[this.keyField];
            clonedChild.visible = !collapse;
            return clonedChild;
          }));
          delete cloned.children;
        };
        this.options = dataSource;
      },

      onExpandClick(item, event) {
        event.cancelBubble = true;
        item.collapse = false;
        this.toggleVisible(item, true);
      },

      onCollapseClick(item, event) {
        event.cancelBubble = true;
        item.collapse = true;
        this.toggleVisible(item, false);
      },

      onSearch() {
        const allParents = this.options.filter((v, i, a) => v.isParent);
        for(let i = 0; i < allParents.length; i++) {
          allParents[i].collapse = false;
          this.toggleVisible(allParents[i], true);
        }
      },

      onSelectedValueChanged(s){
        var isChildren = event.srcElement.className.indexOf("__tree-select-child-item") > -1;
        this.$emit("input", {
          level: isChildren ? 1 : 0, 
          value: Number.parseInt(s.replace("--children--", ""))
        });
      },

      toggleVisible(item, visible){
        const key = item[this.keyField];
        const children = this.options.filter((v, i, a) => v.parentKey === key);
        for(let i = 0; i < children.length; i++) {
          const curr = children[i];
          curr.visible = visible; 
        }
      }
    },
    mounted() {
      this.init();
      this.selectedValue = this.value === null ? null : this.value.value;

      let z =  this.$el.getElementsByTagName("input")[0];
      z.onkeydown = () => {
        this.onSearch();
      }
    },
    watch: {
      dataSource(){
        this.init();
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/common/tree-select.vue